<template>
  <v-container fluid class="px-1 py-1">
    <CommonDetail
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
    >
      <template v-slot:body="{height}">
        <v-sheet class="px-3 py-3">
          <v-row>
            <v-col cols="2">
              <CommonFieldString
                  v-if="!!storeAggregate && !!storeAggregate.rootData && !!currentItem.component_uid && !!storeAggregate.rootData[currentItem.component_uid]"
                  v-model="storeAggregate.rootData[currentItem.component_uid].article_display"
                  label="Article"
                  :readonly="true"
                  class="mt-3"
              ></CommonFieldString>
            </v-col>
            <v-col cols="4">
              <CommonFieldString
                  v-if="!!storeAggregate && !!storeAggregate.rootData && !!currentItem.component_uid && !!storeAggregate.rootData[currentItem.component_uid]"
                  v-model="storeAggregate.rootData[currentItem.component_uid].alias"
                  label="Alias"
                  :readonly="true"
                  class="mt-3"
              ></CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldString
                  v-model="currentItem.quantity"
                  label="Quantity"
                  :readonly="true"
                  class="mt-3"
              ></CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldString
                  v-model="currentItem.need_quantity"
                  label="Need quantity"
                  :readonly="true"
                  class="mt-3"
              ></CommonFieldString>
            </v-col>
            <v-col cols="2">
              <CommonFieldString
                  v-model="currentItem.reservation_quantity"
                  label="Material reservation quantity"
                  :readonly="true"
                  class="mt-3"
              ></CommonFieldString>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <MaterialReservationTable
                  :store-name="storeMaterialReservationTableName"
                  :height="height - 240"
                  :headers="headersMaterialReservation"
                  @alternate_action="onAlternateAction($event)"
              >
                <template v-slot:top>{{ '' }}</template>
              </MaterialReservationTable>
              <!--              :headers="membersHeaders"-->
            </v-col>
            <v-col cols="6">
              <MaterialTable
                  v-if="!!storeAggregate && !!storeAggregate.rootData && !!storeAggregate.rootData[storeDetail.uidItem]"
                  title="Material"
                  :headers="materialHeaders"
                  :store-name="storeMaterialTableName"
                  dto-list-query="MaterialForReservationListQueryDTO"
                  :height="height - 280"
                  @alternate_action="onAlternateAction($event)"
              >
              </MaterialTable>
            </v-col>
          </v-row>
        </v-sheet>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import CommonDetail from "@/components/Common/CommonDetail";
import CommonPartialSelectFromTable from "@/components/Common/CommonPartialSelectFromTable";
import CommonFieldString from "@/components/Common/CommonFieldString";
import {useTableStore} from "@/components/Common/CommonTable";
import {debounce} from "debounce";
import MaterialReservationTable from "@/components/CoreMaterial/MaterialReservation/MaterialReservationTable";
import MaterialTable from "@/components/CoreMaterial/Material/MaterialTable";

export default {
  name: "BatchRunComponentDetail",

  props: {
    uidItem: {default: null},
    embedded: {default: false},
    storeName: {type: [String], default: 'BatchRunComponentDetail'},
    dtoDetailQuery: {default: 'BatchRunComponentDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BatchRunComponentActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'BatchRunComponentSaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'BatchRunComponentValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'BatchRunComponentBaseDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'BatchRunComponentTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    CommonFieldString,
    CommonDetail,
    CommonPartialSelectFromTable,
    MaterialTable,
    MaterialReservationTable,
  },

  computed: {
    storeUidItem() {
      if (!!this.storeDetail)
        return this.storeDetail.uidItem
      else
        return null
    },
    currentItem() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
    componentUid() {
      if (!!this.storeAggregate && !!this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem && !!this.storeAggregate.rootData[this.storeDetail.uidItem])
        return this.storeAggregate.rootData[this.storeDetail.uidItem].component_uid
      else
        return null
    },
  },

  watch: {
    storeUidItem: {
      handler(newValue, oldValue) {
        this.filterMaterialReservation()
        this.filterMaterial()
      }
    },
    componentUid: {
      handler(newValue, oldValue) {
        this.filterMaterial()
      }
    },
  },

  methods: {
    filterMaterialReservation() {
      this.storeMaterialReservationTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'batchrun_component__uid', value: this.storeDetail.uidItem},
        ],
        enable: true,
      }
      this.storeMaterialReservationTable.uidItem = this.storeDetail.uidItem
    },

    filterMaterial() {
      this.storeMaterialTable.query_filters = {
        and_concat: true,
        filter_list: [
          {param_compare: 'component__uid', value: this.componentUid},
        ],
        enable: true,
      }
      this.storeMaterialTable.uidItem = this.storeDetail.uidItem
    },
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()

    this.storeMaterialReservationTable = useTableStore(this.storeMaterialReservationTableName)()
    this.filterMaterialReservation()

    this.storeMaterialTable = useTableStore(this.storeMaterialTableName)()
    this.filterMaterial()

  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeMaterialReservationTable: null,
      storeMaterialReservationTableName: uuidv4(),
      storeMaterialTable: null,
      storeMaterialTableName: uuidv4(),
      materialHeaders: [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      // {text: 'Article', value: 'component__article_display', sortable: true, filterable: true, divider: true},
      // {text: 'Alias', value: 'component__alias', sortable: true, filterable: true, divider: true},
      {text: 'Material owner', value: 'material_owner__name', sortable: true, filterable: true, divider: true},
      {text: 'Usage restriction', value: 'usage_restriction__name', sortable: true, filterable: true, divider: true},
      {text: 'Provider', value: 'material_delivery__provider__name', sortable: true, filterable: true, divider: true},
      {text: 'Delivery number', value: 'material_delivery__delivery_number', sortable: true, filterable: true, divider: true},
      {text: 'P/N', value: 'part_number__part_number', sortable: true, filterable: true, divider: true},
      {text: 'Initial QTY', value: 'initial_qty', sortable: true, filterable: true, divider: true},
      {text: 'Current QTY', value: 'current_qty', sortable: true, filterable: true, divider: true},
      {text: 'Not used QTY', value: 'not_used_qty', sortable: true, filterable: true, divider: true},
      {text: 'Reservation quantity', value: 'reservation_quantity', sortable: true, filterable: true, divider: true, width: 40},
      {text: 'Supply type', value: 'supply_type', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Package', value: 'package', sortable: true, filterable: true, divider: true, width: 40},
      {text: 'Status', value: 'lifecycle', sortable: true, filterable: true, divider: true, width: 100},
      {text: 'Location', value: 'location__name', sortable: true, filterable: true, divider: true, width: 100},
      {
        text: 'Parent location',
        value: 'location__parent__name',
        sortable: true,
        filterable: true,
        divider: true,
        width: 100
      },
      // {text: 'Parent', value: 'parent_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ],
      headersMaterialReservation: [
      {text: 'Material', value: 'material__supply_type', sortable: true, filterable: true, divider: true},
      {text: 'Parent location', value: 'material__parent__location__name', sortable: true, filterable: true, divider: true},
      {text: 'Location', value: 'material__location__name', sortable: true, filterable: true, divider: true},
      {text: 'Article', value: 'material__component__article', sortable: true, filterable: true, divider: true},
      {text: 'Material UID', value: 'material_uid', sortable: true, filterable: true, divider: true},
      {text: 'Reservation quantity', value: 'quantity', sortable: true, true: true, divider: true},
      {text: 'Current QTY', value: 'material__current_qty', sortable: true, true: true, divider: true},
      // {text: 'BatchRun', value: 'batchrun_component__batch_run__name', sortable: true, true: true, divider: true},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      ],
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>